import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../api/store';
import { hideConfirmationDialog } from '../../../store/confirmationDialogSlice';
import { ConfirmationDialog } from './confirmationDialog';

export const GlobalConfirmationDialog: React.FC = () => {
  const dispatch = useDispatch();
  const { isOpen, options } = useSelector((state: RootState) => state.confirmationDialog);

  const handleConfirm = () => {
    if (options?.onConfirm) {
      options.onConfirm();
    }
    dispatch(hideConfirmationDialog());
  };

  const handleCancel = () => {
    if (options?.onCancel) {
      options.onCancel();
    }
    dispatch(hideConfirmationDialog());
  };

  if (!options) return null;

  return (
    <ConfirmationDialog
      open={isOpen}
      title={options.title}
      message={options.message}
      confirmButtonText={options.confirmButtonText}
      cancelButtonText={options.cancelButtonText}
      confirmButtonColor={options.confirmButtonColor}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
    />
  );
};
